module.exports = __webpack_public_path__ + "media/padding.cfc6163e.mp4";